import React, { useReducer, useState } from "react";
import authService from "services/authService";
import {
  FormGroup,
  Button,
  Typography,
  TextField,
  Checkbox,
  InputAdornment,
  IconButton,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { loginFormReducer } from "reducers/formReducers";
import PropTypes from "prop-types";
import tagAdminConstants from "constants/tagAdminConstants";

const initialValue = {
  showPassword: true,
  username: "",
  password: "",
  errors: {},
  openAlert: false,
};

function LoginForm({ responseFunc }) {
  const [formState, dispatch] = useReducer(loginFormReducer, initialValue);
  const [showPassword, setShowPassword] = useState(true);
  const { username, password, errors } = formState;

  const toggleShow = () => {
    setShowPassword(!showPassword);
  };
  const onChange = (e) => {
    dispatch({
      type: e.target.name,
      payload: {
        field: e.target.name,
        value: e.target.value,
      },
    });
  };

  const validateForm = () => {
    let formIsValid = true;
    const issues = {};
    if (!username) {
      formIsValid = false;
      issues.username = "*Please enter your email.";
    } else if (typeof username !== "undefined") {
      const pattern = tagAdminConstants.EMAIL_PATTERN_REGEX;
      if (!pattern.test(username)) {
        formIsValid = false;
        issues.username = "*Please enter valid email.";
      }
    }

    if (!password) {
      formIsValid = false;
      issues.password = "*Please enter your password.";
    }
    dispatch({
      type: "validation",
      payload: {
        issues,
      },
    });
    return formIsValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationResults = validateForm();
    if (validationResults) {
      authService.loginUser(username, password).then((response) => {
        responseFunc(response);
      });
    }
  };

  return (
    <form className="b-loginform-container" onSubmit={handleSubmit}>
      {/* <Typography className="default-card-body-padding">
       
      </Typography> */}
      <h3 className="b-loginform-container__welcomeText default-card-body-padding">
        Welcome Back
      </h3>

      <div className="b-loginform-container__left-padding" id="underlinehide">
        <FormLabel
          htmlFor="username"
          className="b-loginform-container__label-text"
        >
          Email
        </FormLabel>
        <TextField
          className="b-loginform-container__text-Email-field"
          name="username"
          id="username"
          value={username}
          onChange={onChange}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
        />
        {errors && errors.username !== "" && (
          <span className="b-loginform-container__errorMsg errorMsg">
            {errors.username}
          </span>
        )}
      </div>
      <div className="b-loginform-container__left-padding" id="underlinehide">
        <FormLabel
          htmlFor="password"
          className="b-loginform-container__label-text"
        >
          Password
        </FormLabel>
        <TextField
          className="b-loginform-container__text-password-field"
          name="password"
          id="password"
          type={showPassword ? "password" : "text"}
          value={password}
          onChange={onChange}
          variant="standard"
          InputProps={{
            disableUnderline: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  className="b-loginform-container__possword_icon"
                  onClick={toggleShow}
                >
                  {showPassword === false ? (
                    <VisibilityOutlinedIcon />
                  ) : (
                    <VisibilityOffOutlinedIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {errors && errors.password !== "" && (
          <span className="b-loginform-container__errorMsg errorMsg">
            {errors.password}
          </span>
        )}
      </div>
      <FormGroup>
        <FormControlLabel
          className="left-padding"
          control={<Checkbox />}
          label={
            <Typography className="remove">
              <span className="b-loginform-container__remember">
                Remember Me
              </span>
            </Typography>
          }
        />
      </FormGroup>
      <div className="b-loginform-container__loginhead">
        <Button
          variant="outlined"
          type="submit"
          className=" b-loginform-container__loginbtn"
        >
          <span className="form-button-text"> Login </span>
        </Button>
      </div>
    </form>
  );
}

LoginForm.propTypes = {
  responseFunc: PropTypes.func.isRequired,
};

export default LoginForm;
